import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Store } from './store';
import List from './List';
import ReplyModal from './ReplyModal';

const Comments = ({ subjectId, replyId, allowComment = true, docUrl, docName, skey }) => {
    const initialState = {
        list: [],
        subjectId: '',
        page: 1,
        total: 0,
        topIdList: [],
        showReplyModal: false,
        replyLisRootId: '',
        replyList: [],
        replyPage: 1,
        likeMessage: {},
        docMeta: {
            docUrl: docUrl || (subjectId ? `ucms_${subjectId}` : ''),
            docName: docName || '',
            skey: skey || '',
        },
    };

    return (
        <Store.Provider initialState={initialState}>
            <List subjectId={subjectId} replyId={replyId} allowComment={allowComment} />
            <ReplyModal allowComment={allowComment} />
        </Store.Provider>
    );
};

Comments.propTypes = {
    subjectId: PropTypes.string,
    replyId: PropTypes.string,
    allowComment: PropTypes.bool,
    docUrl: PropTypes.string,
    docName: PropTypes.string,
    skey: PropTypes.string,
};

export default errorBoundary(Comments);
